import * as React from "react";
import Component from "../../AbstractComponent";
import { AttachmentInterface } from "../../../Entity/Entities/Attachment/AttachmentInterface";

class EntityAvatar extends Component {

  public state: {
    avatar: AttachmentInterface
  } = {
    avatar: null
  };

  constructor(public props) {
    super(props);
  }

  public change(avatar): any {
    this.setState({
      avatar: avatar
    });
  }

  public revert(): any {
    return this.setState({
      avatar: null
    });
  }

  public render() {
    const avatar = this.state.avatar;

    return (
      <div>
        {!!avatar ?
          this.image.getAvatarAbsolutely(avatar.cropImgPath, null, { size: 40 }) :
            (<div>
              {this.image.getAvatarAbsolutely("", this.props.entityName, { size: 40 })}
            </div>)
        }
      </div>
    );
  }
}

export { EntityAvatar };
